import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-transmettre-dialog',
  templateUrl: './transmettre-dialog.component.html',
  styleUrls: ['./transmettre-dialog.component.scss']
})
export class TransmettreDialogComponent implements OnInit {

  res: any = {
    comment : "",
    validate : true
  };
  constructor() { }

  ngOnInit() {
  }

}
